import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import {
    ComissaoAssinanteResponse,
    ComissaoCargoAssinanteResponse,
    ComissaoConfiguracaoRequest,
    ComissaoConfiguracaoResponse,
    ComissaoLocalReuniaoConfiguracaoResponse,
    ComissaoLocalReuniaoRequest,
    ComissaoModeloAtaConfiguracaoResponse,
    ComissaoModeloAtaStatusRequest
} from '@/core/api/sicom-api/comissoes/configuracoes/comissao-configuracao.model';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class ComissaoConfiguracaoService extends BaseService {
    readonly PATH = environment.basePath + '/comissoes/configuracoes';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    consultar(idEstruturaOrganizacional: number, context?: HttpContext): Observable<ComissaoConfiguracaoResponse> {
        return this.http.get<ComissaoConfiguracaoResponse>(`${this.PATH}/${idEstruturaOrganizacional}`, { context });
    }

    salvar(idEstruturaOrganizacional: number, request: ComissaoConfiguracaoRequest, context?: HttpContext): Observable<ComissaoConfiguracaoResponse> {
        return this.http.put<ComissaoConfiguracaoResponse>(`${this.PATH}/${idEstruturaOrganizacional}`, request, { context });
    }

    listarModelosAta(_context?: HttpContext): Observable<ComissaoModeloAtaConfiguracaoResponse[]> {
        // Chamada desativada temporariamente: endpoint consulta a tabela SCCT_MODELO_ATA.
        // return this.http.get<ComissaoModeloAtaConfiguracaoResponse[]>(`${this.PATH}/modelos-ata`, { context });
        return of([]);
    }

    atualizarStatusModeloAta(_idModeloAta: number, _request: ComissaoModeloAtaStatusRequest, _context?: HttpContext): Observable<void> {
        // Chamada desativada temporariamente: endpoint atualiza a tabela SCCT_MODELO_ATA.
        // return this.http.put<void>(`${this.PATH}/modelos-ata/${idModeloAta}/status`, request, { context });
        return of(void 0);
    }

    listarCargosAssinante(context?: HttpContext): Observable<ComissaoCargoAssinanteResponse[]> {
        return this.http.get<ComissaoCargoAssinanteResponse[]>(`${this.PATH}/cargos-assinante`, { context });
    }

    buscarAssinantePorCargo(idCargo: number, context?: HttpContext): Observable<ComissaoAssinanteResponse> {
        return this.http.get<ComissaoAssinanteResponse>(`${this.PATH}/cargos-assinante/${idCargo}/assinante`, { context });
    }

    listarLocaisReuniao(context?: HttpContext): Observable<ComissaoLocalReuniaoConfiguracaoResponse[]> {
        return this.http.get<ComissaoLocalReuniaoConfiguracaoResponse[]>(`${this.PATH}/locais-reuniao`, { context });
    }

    inserirLocalReuniao(request: ComissaoLocalReuniaoRequest, context?: HttpContext): Observable<ComissaoLocalReuniaoConfiguracaoResponse> {
        return this.http.post<ComissaoLocalReuniaoConfiguracaoResponse>(`${this.PATH}/locais-reuniao`, request, { context });
    }

    atualizarLocalReuniao(idLocalReuniao: number, request: ComissaoLocalReuniaoRequest, context?: HttpContext): Observable<ComissaoLocalReuniaoConfiguracaoResponse> {
        return this.http.put<ComissaoLocalReuniaoConfiguracaoResponse>(`${this.PATH}/locais-reuniao/${idLocalReuniao}`, request, { context });
    }

    atualizarStatusLocalReuniao(idLocalReuniao: number, request: ComissaoModeloAtaStatusRequest, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}/locais-reuniao/${idLocalReuniao}/status`, request, { context });
    }

    excluirLocalReuniao(idLocalReuniao: number, context?: HttpContext): Observable<void> {
        return this.http.delete<void>(`${this.PATH}/locais-reuniao/${idLocalReuniao}`, { context });
    }
}
